import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classname';

import Login from '../login/main';
import Langs from '../langs/main';
import Logo from '../logo/main';
import Hamburger from '../hamburger/main';

const Main = ({
	intl, user, availableLanguages, lang,
	changeLang, isHamburgerActive, navbarMenu,
	handleHamburgerClick, logout
}) => {
	return (
		<header className='market-header'>
			<Logo isHamburgerActive={isHamburgerActive} />
			<div className='market-header__hamburger'>
				<Hamburger
					intl={intl}
					isHamburgerActive={isHamburgerActive}
					navbarMenu={navbarMenu}
					handleHamburgerClick={handleHamburgerClick}
				/>
			</div>
			<div className={cn({
				'market-header__mobile-header': true,
				'active': isHamburgerActive
			})}>
				<div className='mobile-header__menues'>
					{navbarMenu.map(menu => menu.isLink
						? <Link key={menu.title}  className={`navbar__item ${menu.activeClass}`} to={menu.to} >
							{intl(menu.title)}</Link>
						: <a key={menu.title}  className={`navbar__item ${menu.activeClass}`} href={menu.to}>
							{intl(menu.title)}</a>
					)}
				</div>
				<Login
					intl={intl}
					user={user}
					isHamburgerActive={isHamburgerActive}
					logout={logout}
				/>
			</div>
			<nav className='market-header__navbar'>
				{navbarMenu.map(menu => menu.isLink
					? <Link key={menu.title}  className={`navbar__item ${menu.activeClass}`} to={menu.to} >
						{intl(menu.title)}</Link>
					: <a key={menu.title}  className={`navbar__item ${menu.activeClass}`} href={menu.to}>
						{intl(menu.title)}</a>
				)}
			</nav>
			<div className='market-header__actions'>
				<Langs
					intl={intl}
					availableLanguages={availableLanguages}
					lang={lang}
					changeLang={changeLang}
					isHamburgerActive={isHamburgerActive}
				/>
				<Login
					intl={intl}
					user={user}
					logout={logout}
				/>
			</div>
		</header>
	);
};

Main.propTypes = {
	intl: PropTypes.func,
	user: PropTypes.object,
	availableLanguages: PropTypes.array,
	lang: PropTypes.string,
	changeLang: PropTypes.func,
	isHamburgerActive: PropTypes.bool,
	navbarMenu: PropTypes.array,
	handleHamburgerClick: PropTypes.func,
	logout: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/header/main.js